<agr-summary-card [title]="'TGA.WaterAuthorityExceedances' | translate" [actions]="cardActions">
  <div class="water-authorities">
    @if (loading) {
      <div class="loading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      @for (wa of waterAuthorities; track wa.title) {
        <section class="water-authority">
          <h3 class="title">{{ wa.title }}</h3>

          <table class="exceedance-table">
            <thead>
              <tr>
                <th>{{ 'TGA.WaterAuthorityExceedancesTable.Substance' | translate }}</th>
                <th>{{ 'TGA.WaterAuthorityExceedancesTable.ExampleProduct' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (exceedance of wa.exceedances; track exceedance.substance) {
                <tr>
                  <td>{{ exceedance.substance }}</td>
                  <td>{{ exceedance.example }}</td>
                </tr>
              }
            </tbody>
          </table>
        </section>
      }
    }
  </div>
</agr-summary-card>
